import { initCarousels } from "../carousel/";

// ============================================================================
// About page carousel wiring
// ----------------------------------------------------------------------------
// The about hero reuses the same `.page--home--hero-slider--container` class
// as the home hero (they share visual styling). Fade transition, autoplay,
// no nav buttons.
// ============================================================================

document.addEventListener("DOMContentLoaded", function () {
  initCarousels(".page--home--hero-slider--container", {
    fade: true,
    contain: true,
    pageDots: false,
    wrapAround: true,
    autoPlay: 3800,
  });
});
